module.exports = __webpack_public_path__ + "static/media/bouquet.aa19c9ac.png";